module.exports = __webpack_public_path__ + "img/fs.62aaef3f.png";